<ion-content>
  <div class="full-height vertical-center">
    <ion-card class="main-card center">
      <ion-card-header class="font-20 font-bold ion-text-center">
        <ng-container *ngIf="accountInfo?.title?.value">
          {{ accountInfo.title.value }}
        </ng-container>
        <ng-container *ngIf="!accountInfo?.title?.value">
          <ng-container *ngIf="accountInfo?.coupleList?.length === 2 && accountInfo?.coupleList[0]?.name && accountInfo?.coupleList[1]?.name else titleBlock">
            {{ 'ACCOUNT.auto_title' | translate: { couple1: accountInfo.coupleList[0].name, couple2: accountInfo.coupleList[1].name } }}
          </ng-container>
          <ng-template #titleBlock>
            {{ 'ACCOUNT.lbl.wedding_title' | translate }}
          </ng-template>
        </ng-container>
      </ion-card-header>
      <ion-card-content>
        <ion-card class="ion-no-margin" color="tertiary" *ngIf="days || hours || minutes">
          <ion-grid fixed>
            <ion-row>
              <ion-col class="ion-text-center">
                <div><ion-text class="font-28 font-bold" color="dark">{{ days ? days : 0 }}</ion-text></div>
                <ion-label class="font-10" color="dark">{{ 'LBL.days' | translate }}</ion-label>
              </ion-col>
              <ion-col class="ion-text-center">
                <div><ion-text class="font-28 font-bold" color="dark">{{ hours ? hours : 0 }}</ion-text></div>
                <ion-label class="font-10" color="dark">{{ 'LBL.hours' | translate }}</ion-label>
              </ion-col>
              <ion-col class="ion-text-center">
                <div><ion-text class="font-28 font-bold" color="dark">{{ minutes ? minutes : 0 }}</ion-text></div>
                <ion-label class="font-10" color="dark">{{ 'LBL.minutes' | translate }}</ion-label>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card>
        <div class="ion-text-left font-14">
          <div class="ion-margin">
            <ion-item class="ion-item-no-padding info-item" lines="none">
              <ion-icon class="icon-small" slot="start" name="calendar-outline"></ion-icon>
              <ion-text *ngIf="accountInfo?.time?._seconds else emptyBlock">{{ format(accountInfo.time._seconds * 1000, 'date', accountInfo?.timezone?.name) }}</ion-text>
            </ion-item>
            <ion-item class="ion-item-no-padding info-item" lines="none">
              <ion-icon class="icon-small" slot="start" name="time-outline"></ion-icon>
              <ion-text *ngIf="accountInfo?.time?._seconds else emptyBlock">{{ format(accountInfo.time._seconds * 1000, 'time', accountInfo?.timezone?.name) }} &nbsp;<span class="font-10">({{ accountInfo.timezone.utc }})</span></ion-text>
            </ion-item>
            <ion-item class="ion-item-no-padding info-item" lines="none">
              <ion-icon class="icon-small" slot="start" name="person-outline"></ion-icon>
              <ion-text *ngIf="coupleList?.[1] as couple else emptyBlock">{{ 'LIST.wedding_couple_type.' + couple.accountCouple.coupleType | translate }}: {{ couple.name }}</ion-text>
            </ion-item>
            <ion-item class="ion-item-no-padding info-item" lines="none">
              <ion-icon class="icon-small" slot="start" name="person-outline"></ion-icon>
              <ion-text *ngIf="coupleList?.[2] as couple else emptyBlock">{{ 'LIST.wedding_couple_type.' + couple.accountCouple.coupleType | translate }}: {{ couple.name }}</ion-text>
            </ion-item>
            <ion-item class="ion-item-no-padding info-item" lines="none">
              <ion-icon class="icon-small ion-align-items-start" slot="start" src="./assets/wedding/icon/general/location.svg"></ion-icon>
              <ion-text>
                <div *ngIf="accountInfo?.location?.name || accountInfo?.location?.address else emptyBlock">
                  <div *ngIf="accountInfo?.location?.name">
                    {{ accountInfo.location.name }}
                  </div>
                  <div class="font-10" *ngIf="accountInfo?.location?.address">
                    {{ accountInfo.location.address }}
                  </div>
                </div>
              </ion-text>
            </ion-item>
          </div>
          <ng-template #emptyBlock>
            <ion-text>-</ion-text>
          </ng-template>
        </div>
        <ion-button expand="block" (click)="dismissModal()">
          {{ 'BTN.close' |translate }}
        </ion-button>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>